<template>
  <div class="container">
    <breadcrumb-group :items="breadcrumbItems"/>
    <heading-one>ご登録口座からのお引落し</heading-one>

    <list-group>
      <list-item>口座からの自動引落しになるため、毎月忘れずにご返済いただけます。</list-item>
      <list-item>ご返済日は26日※となります。ご返済金額をご確認のうえ、ご返済日前日までにご登録口座へご入金ください。</list-item>
    </list-group>
    <list-group class="-note">
      <list-item class="-note">金融機関休業日の場合は翌営業日となります。その場合は、金融機関休業前営業日までにご登録口座へのご入金をお願いいたします。</list-item>
    </list-group>

    <section>
      <heading-two>お引落し口座のご登録について</heading-two>
      <list-group class="-normal">
        <list-item class="-normal">お引落しの金融機関口座は、新規お申し込み時、または、ご契約後に会員さま専用サイトにてご登録が可能です。</list-item>
        <list-item class="-normal">ご登録には、金融機関の支店名・口座番号などのご入力が必要なため、ご本人さま名義の通帳・キャッシュカードなどのご準備をお願いいたします。</list-item>
      </list-group>
      <list-group class="-link _mt-md-20">
      <list-item class="-link" routerName="sv018">ご登録可能な金融機関について</list-item>
      </list-group>
    </section>

    <section>
      <step-list type="sv" class="_mb-md-60 _mb-sm-20 -green">
        <heading-two>会員さま専用サイトでの口座の登録・変更方法について</heading-two>
        <step-item number="1" title="会員さま専用サイトへログイン" src="sv/sv026/img01.jpg" src-sp="sv/sv026/sp/img01.jpg">
          <p>会員さま専用サイトへログインします。</p>
          <btn-main class="-normal" routerName="ce001">
            会員さま専用サイトトップへ
          </btn-main>
        </step-item>
        <step-item number="2" title="「口座情報の登録・変更」を選択" src="sv/sv026/img02.jpg" src-sp="sv/sv026/sp/img02.jpg" class="-last">
          <p>ログイン後に会員さま専用サイトの「お借り入れ・ご返済時に便利な口座登録について」または「お客さま情報」メニュー内にある「口座情報の登録・変更」よりお手続きください。</p>
        </step-item>
        <step-footer>
          <template slot="heading">お手続き完了</template>
          <template slot="text">
            <p class="_mt-15">ご登録の口座からのご返済（口座振替）開始時期は、翌月からとなる場合がございます。ご返済方法は、メールまたは、会員さま専用サイトのメッセージにてご連絡する【次回ご返済金額のお知らせ】をご確認ください。</p>
          </template>
        </step-footer>
      </step-list>
    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <heading-two>お引落し以外の任意のご返済について</heading-two>
      <p>お引落し以外の任意のご返済は、お客さま専用口座へのお振込みまたはセブン銀行ATMでお受けいたします。</p>

      <notice-box class="-alert _mb-md-20 _mb-sm-10">
        <notice-header>
          <h2 class="heading">【ご注意ください】</h2>
        </notice-header>
        <notice-body>
          お引落し日の８営業日（金融機関営業日）前以降に任意でご返済いただいた場合、当月26日＊のお引落しもございます。
        </notice-body>
      </notice-box>
      <div class="_mb-md-60 _mb-sm-30">
        <small>* 金融機関休業日の場合は、翌営業日となります。</small>
      </div>

      <p class="_mb-md-30 _mb-sm-20">ご返済日間近での任意返済の場合、期日返済まで短期間でのご返済が必要となります。計画的なご返済をいただきますようお願いいたします。</p>

      <div class="_textcenter">
        <img src="@/assets/images/sv/sv026/img05.png" class="-spnone" alt="">
        <img src="@/assets/images/sv/sv026/sp/img05.png" class="img-fluid -pcnone" alt="">
      </div>
    </section>

    <cv-box class="_mb-md-120 _mb-sm-60"/>

    <contact-box class="_mb-md-120 _mb-sm-60"/>

    <!--</section>-->
  </div><!-- container -->
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import HeadingTwo from '../components/heading/HeadingTwo'
import StepList from '../components/steps/StepList'
import StepItem from '../components/steps/StepItem'
import StepFooter from '../components/steps/StepFooter'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnText from '../components/button/BtnText'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import CvBox from '../components/box/CvBox'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import ContactBox from '../components/box/ContactBox'
import NoticeBox from '../components/box/NoticeBox'
import NoticeHeader from '../components/box/NoticeHeader'
import NoticeBody from '../components/box/NoticeBody'

export default {
  name: 'Sv-026',
  metaInfo: {
    title: 'ご登録口座からのお引落し｜ご返済方法',
    meta: [
      {name: 'description', content: 'ご登録口座からのお引落しによるご返済方法についてご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,登録口座,お引き落し'}
    ]
  },
  components: {
    ContactBox,
    CardBody,
    CardHeader,
    CardBox,
    CvBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtngroupSingle,
    BtnMain,
    BtnText,
    ListItem,
    ListGroup,
    StepFooter,
    StepItem,
    StepList,
    HeadingOne,
    HeadingTwo,
    NoticeBox,
    NoticeHeader,
    NoticeBody
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: 'ご返済について',
        routerName: 'sv047'
      },
      {
        text: 'ご登録口座からのお引落し',
        active: true
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
</style>



// WEBPACK FOOTER //
// src/pages/Sv026.vue